import { Component, OnDestroy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import * as _ from 'lodash';

@Component({
    styles: [`
        mat-dialog-content {
            width: 525px;
        }
    `],
    template: `
        <h2 mat-dialog-title>Change Source</h2>
        <mat-dialog-content  [formGroup]="form" fxLayout="column">
            <mat-form-field>
                <input matInput formControlName="username" placeholder="Factiva Customer ID">
                <mat-error *ngIf="form.get('username').hasError('required')">Factiva Customer ID is required.</mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="uri" placeholder="Folder Name">
                <mat-error *ngIf="form.get('uri').hasError('required')">Folder Name is required.</mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="password" placeholder="Password">
                <mat-error *ngIf="form.get('password').hasError('required')">Password is required.</mat-error>
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions>
        <button mat-raised-button color="primary" [disabled]="form.invalid" [mat-dialog-close]="form.value">Select</button>
        <button mat-button mat-dialog-close>Cancel</button>
        </mat-dialog-actions>
    `
})
export class FactivaChangeSourceDialogComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    form: FormGroup;
    source: any;
    
    constructor(fb: FormBuilder,  @Inject(MAT_DIALOG_DATA) public data: any) {
        this.source = data.source;
        this.form = fb.group({
            uri: [this.source.uri, Validators.required],
            username: [this.source.username, Validators.required],
            password: [this.source.password, Validators.required]
        });
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
